module.exports = __webpack_public_path__ + "static/media/07.5835f0e9.png";